module.exports = __webpack_public_path__ + "img/Brand_ml.6e756fbc.png";